import { css } from 'lit';
export const styles = css`/*
 * @triptease/stylesheet v3.0.2
 */


@layer base{

/**
 * Do not edit directly, this file was auto-generated.
 */

:root {
  --asset-font-noe-text-name: 'Noe Text';
  --asset-font-noe-text-style: normal;
  --asset-font-noe-text-weight: 400;
  --asset-font-inter-name: Inter;
  --asset-font-inter-style: normal;
  --color-alert-subtle: #ffd8eb;
  --color-alert-strong: #d02521;
  --color-border-100: #e8eaec;
  --color-border-200: #e0e1e5;
  --color-border-300: #d7d9dd;
  --color-border-400: #c5c8ce;
  --color-border-500: #b7bbc2;
  --color-text-100: #ffffff;
  --color-text-200: #b5b0b5;
  --color-text-300: #575157;
  --color-text-400: #3b353b;
  --color-text-500: #0d0c0d;
  --color-text-inverted-100: #0d0c0d;
  --color-text-inverted-200: #77758a;
  --color-text-inverted-300: #9d9cab;
  --color-text-inverted-400: #d3d3da;
  --color-text-inverted-500: #ffffff;
  --color-info-subtle: #f0f8ff;
  --color-info-strong: #2475b9;
  --color-primary-100: #f3f0fa;
  --color-primary-200: #e8e3f6;
  --color-primary-300: #cfc6ed;
  --color-primary-400: #5e43c2;
  --color-primary-500: #4d35a1;
  --color-success-subtle: #def5d6;
  --color-success-strong: #227d02;
  --color-surface-100: #ffffff;
  --color-surface-200: #f9fafb;
  --color-surface-300: #f1f2f4;
  --color-surface-400: #e8eaec;
  --color-surface-500: #e0e1e5;
  --color-surface-600: #d7d9dd;
  --color-surface-700: #75767e;
  --color-surface-800: #1c1b27;
  --color-surface-inverted-100: #1c1b27;
  --color-surface-inverted-200: #3a384d;
  --color-surface-inverted-300: #5b5974;
  --color-surface-inverted-400: #7f7d95;
  --color-surface-inverted-500: #acaabc;
  --color-warning-subtle: #ffedd6;
  --color-warning-strong: #ac5500;
  --font-family-serif: 'Noe Text', 'PT Serif', serif;
  --font-family-sans: 'Roboto', sans-serif;
  --font-family-inter: 'Inter', 'Helvetica Neue', sans-serif;
  --font-line-height-100: 1.4; /** Line height for small text */
  --font-line-height-200: 1.5; /** Line height for body text */
  --font-line-height-300: 1.3; /** Line height for heading 3 text */
  --font-line-height-400: 1.4; /** Line height for heading 2 text */
  --font-line-height-500: 1.3; /** Line height for heading 1 text */
  --font-line-height-600: 1.5; /** Line height for display text */
  --font-size-100: 0.875rem; /** Small text */
  --font-size-200: 1rem; /** Body text */
  --font-size-300: 1.125rem; /** Heading 3 text */
  --font-size-400: 1.25rem; /** Heading 2 text */
  --font-size-500: 1.5rem; /** Heading 1 text */
  --font-size-600: 2rem; /** Display text */
  --font-weight-light: 300;
  --font-weight-normal: 400; /** This is called 'regular' in Figma. */
  --font-weight-medium: 500;
  --font-weight-semibold: 600;
  --font-weight-bold: 700;
  --space-scale-1: 0.5rem;
  --space-scale-2: 1rem;
  --space-scale-3: 1.5rem;
  --space-scale-4: 2.5rem;
  --space-scale-5: 3.5rem;
  --space-scale-6: 4.5rem;
  --space-scale-7: 5.5rem;
  --space-scale-8: 6.5rem;
  --space-scale-9: 7.5rem;
  --space-scale-10: 8.5rem;
  --space-scale-0-5: 0.25rem;
  --space-scale-1-5: 0.75rem;
  --space-scale-2-5: 1.25rem;
  --space-scale-3-5: 2rem;
  --space-scale-4-5: 3rem;
  --space-scale-5-5: 4rem;
  --space-scale-6-5: 5rem;
  --space-scale-7-5: 6rem;
  --space-scale-8-5: 7rem;
  --space-scale-9-5: 8rem;
  --border-radius: 0.5rem; /** Legacy border radius, use 'border-radius-100' instead */
  --border-radius-50: 0.25rem; /** Small border radius for badges and other small visual components */
  --border-radius-100: 0.5rem;
  --border-radius-200: 1rem;
  --box-shadow-sm: 0 1px 0 0 #E8EAEC;
  --box-shadow-md: 0 8px 12px 0 rgba(0, 0, 0, 0.08), 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  --box-shadow-lg: 0 50px 100px 0 rgba(60, 66, 87, 0.08), 0 15px 35px 0 rgba(60, 66, 87, 0.08), 0 5px 15px 0 rgba(0, 0, 0, 0.12);
  --box-shadow-lg-hover: 0px 10px 20px rgba(0, 0, 0, 0.2); /** Large box shadow used for hover effects */
}
}
@layer base{

/* http://meyerweb.com/eric/tools/css/reset/
   v2.0 | 20110126
   License: none (public domain)
*/

html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
  font-smoothing: antialiased;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

ol,
ul {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: '';
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

body {
  font-family: var(--font-family-inter);
  font-size: 16px;
  color: var(--color-text-500);
  line-height: 1;
  background-color: var(--color-surface-200);
  min-height: 100vh;
}

button {
  font-family: inherit;
  font-size: inherit;
}
}
/*
  Suppress "invalid at-rule" warnings: @import-glob is a build-time feature
  handled by our bundler, not standard CSS. WebStorm doesn't recognize it.
*/
/* noinspection CssInvalidAtRule */
@layer base{

button,
.button {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  cursor: pointer;
  position: relative;
  height: -moz-max-content;
  height: max-content;
  font-size: var(--font-size-200);
  font-weight: var(--font-weight-semibold);
  line-height: var(--space-scale-3);
  padding: var(--space-scale-1) var(--space-scale-1-5);
  border-radius: var(--border-radius-100);
  border: none;
  outline: none;
  transition:
    background-color 0.3s ease,
    box-shadow 0.3s ease;
  background-color: transparent;
  color: var(--color-text-500);
  width: -moz-fit-content;
  width: fit-content;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: var(--space-scale-1);

  &:is([disabled], [aria-disabled='true']) {
    cursor: not-allowed;
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 4px solid rgba(1, 150, 237, 0.24);
    outline-offset: 0;
  }

  &[data-theme='primary'] {
    background-color: var(--color-primary-400);
    color: var(--color-text-100);
    border: 1px solid var(--color-primary-500);
    box-shadow:
      inset 0 -2px 2px 0 var(--color-primary-400),
      inset 0 0 0 1px rgba(255, 255, 255, 0.16),
      0 1px 2px rgba(94, 66, 194, 0.2);

    &:hover:not(:disabled):not([aria-disabled='true']) {
      background-color: var(--color-primary-500);
    }

    &:disabled {
      background-color: var(--color-primary-300);
      box-shadow: none;
      border-color: var(--color-primary-300);
    }

    &[data-loading='true'] {
      background-color: var(--color-primary-300);
      box-shadow: none;
      border-color: var(--color-primary-200);
    }
  }

  &[data-theme='secondary'] {
    background-color: var(--color-surface-200);
    color: var(--color-primary-400);
    border: 1px solid var(--color-primary-400);
    box-shadow:
      inset 0 -2px 2px 0 rgba(224, 225, 229, 0.56),
      inset 0 0 0 2px rgba(255, 255, 255, 0.4),
      0 1px 2px 0 rgba(60, 66, 87, 0.08);

    &:hover:not(:disabled):not([aria-disabled='true']) {
      color: var(--color-primary-500);
      background-color: var(--color-surface-300);
      border: 1px solid var(--color-primary-500);
    }

    &:disabled {
      box-shadow: none;
      border-color: var(--color-primary-300);
      color: var(--color-primary-300);
    }

    &[data-loading='true'] {
      border-color: var(--color-primary-300);
      box-shadow: none;
    }
  }

  &[data-theme='suggestion'] {
    padding: var(--space-scale-1) var(--space-scale-2);
    background-color: var(--color-surface-200);
    color: var(--color-primary-400);
    border: 1px solid var(--color-primary-400);
    line-height: var(--space-scale-2);
    font-weight: var(--font-weight-normal);
    font-size: var(--font-size-100);
    border-radius: var(--border-radius-200);
    box-shadow:
      inset 0 -2px 2px 0 rgba(224, 225, 229, 0.56),
      inset 0 0 0 2px rgba(255, 255, 255, 0.4),
      0 1px 2px 0 rgba(60, 66, 87, 0.08);

    &:hover:not(:disabled):not([aria-disabled='true']) {
      background-color: var(--color-surface-300);
    }
  }

  &[data-theme='tertiary'] {
    color: var(--color-primary-400);

    &:disabled {
      box-shadow: none;
      color: var(--color-primary-300);
    }

    &:hover:not(:disabled):not([aria-disabled='true']) {
      background-color: var(--color-primary-100);
      color: var(--color-primary-500);
    }

    &[data-loading='true'] {
      box-shadow: none;
    }
  }

  &[data-theme='destructive-primary'] {
    --color-disabled: #890000;

    background-color: var(--color-alert-strong);
    color: var(--color-text-100);
    border: 1px solid var(--color-alert-strong);
    box-shadow:
      inset 0 -2px 2px 0 rgba(168, 5, 5, 0.56),
      inset 0 0 0 1px rgba(255, 255, 255, 0.24),
      0 1px 2px rgba(60, 66, 87, 0.08);

    &:hover:not(:disabled):not([aria-disabled='true']) {
      background-color: --color-disabled;
    }

    &:disabled {
      background-color: var(--color-alert-subtle);
      box-shadow: none;
      border-color: var(--color-alert-subtle);
    }

    &[data-loading='true'] {
      background-color: var(--color-alert-subtle);
      box-shadow: none;
      border-color: var(--color-alert-subtle);

      &::after {
        background-color: var(--color-surface-100);
      }
    }
  }

  &[data-theme='destructive-secondary'] {
    background-color: var(--color-surface-200);
    color: var(--color-alert-strong);
    border: 1px solid var(--color-alert-strong);
    box-shadow:
      inset 0 -2px 2px 0 rgba(224, 225, 229, 0.56),
      inset 0 0 0 2px rgba(255, 255, 255, 0.4),
      0 1px 2px 0 rgba(60, 66, 87, 0.08);

    &:hover:not(:disabled):not([aria-disabled='true']) {
      border-color: --color-disabled;
      color: --color-disabled;
    }

    &:disabled {
      box-shadow: none;
      border-color: var(--color-alert-subtle);
      color: var(--color-alert-subtle);
    }

    &[data-loading='true'] {
      box-shadow: none;

      &::after {
        background-color: var(--color-alert-strong);
      }
    }
  }

  &[data-theme='destructive-tertiary'] {
    color: var(--color-alert-strong);

    &:disabled {
      box-shadow: none;
      color: var(--color-alert-subtle);
    }

    &:hover:not(:disabled):not([aria-disabled='true']) {
      background-color: --color-disabled;
      color: --color-disabled;
    }

    &[data-loading='true'] {
      box-shadow: none;

      &::after {
        background-color: var(--color-alert-strong);
      }
    }
  }

  &.small {
    padding: var(--space-scale-0-5) var(--space-scale-1);
  }

  &.large {
    padding: var(--space-scale-1-5) var(--space-scale-2);
  }

  &[data-loading='true'] {
    position: relative;
    color: transparent !important;
    pointer-events: none;
    cursor: not-allowed;
    -webkit-user-select: none;
       -moz-user-select: none;
            user-select: none;
  }

  /*Spinner magic*/

  &[data-loading='true']::after {
    content: '';
    position: absolute;
    top: calc(50% - 10px);
    left: calc(50% - 10px);
    width: 20px;
    height: 20px;
    transform: translate(-50%, -50%);
    mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 18 18'%3E%3Cpath fill='none' fill-rule='evenodd' stroke='white' stroke-linecap='round' stroke-width='2' d='M9 1a8 8 0 1 0 0 16 8 8 0 0 0 8-8'/%3E%3C/svg%3E");
    -webkit-mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 18 18'%3E%3Cpath fill='none' fill-rule='evenodd' stroke='white' stroke-linecap='round' stroke-width='2' d='M9 1a8 8 0 1 0 0 16 8 8 0 0 0 8-8'/%3E%3C/svg%3E");
    mask-size: contain;
    -webkit-mask-size: contain;
    background-color: var(--color-primary-400);
    animation: spin-animation 1s infinite linear;
  }
}

@keyframes spin-animation {
  from {
    transform: rotate(0turn);
  }
  to {
    transform: rotate(1turn);
  }
}
}
@layer base{

@font-face {
  font-family: 'Noe Text';
  src:
    url('assets/fonts/Noe/noeTextBook.woff') format('woff'),
    url('assets/fonts/Noe/noeTextBook.ttf') format('truetype');
}

@font-face {
  font-family: 'Noe Display';
  src:
    url('assets/fonts/Noe/noeDisplayRegular.woff') format('woff'),
    url('assets/fonts/Noe/noeDisplayRegular.ttf') format('truetype');
}
}
@layer base{
@property --input-horizontal-spacing {
  syntax: '<length>';
  inherits: true;
  initial-value: 1rem;
}

@property --input-background-color {
  syntax: '<color>';
  inherits: true;
  initial-value: #FFFFFF;
}

@property --input-border-color {
  syntax: '<color>';
  inherits: true;
  initial-value: #C5C8CE;
}

@property --input-border-width {
  syntax: '<length>';
  inherits: true;
  initial-value: 1px;
}

@property --input-color {
  syntax: '*';
  inherits: true;
  initial-value: inherit;
}

@property --input-height {
  syntax: '<length>';
  inherits: true;
  initial-value: 2.5rem;
}

@property --input-vertical-spacing {
  syntax: '<length>';
  inherits: true;
  initial-value: 0;
}

@property --placeholder-color {
  syntax: '<color>';
  inherits: true;
  initial-value: #575157;
}

@property --input-focus-border-color {
  syntax: '<color>';
  inherits: true;
  initial-value: #5E43C2;
}
}
@layer base{

input[type='checkbox'] {
  accent-color: var(--color-primary-400);
  width: var(--space-scale-2);
  aspect-ratio: 1;

  &[aria-invalid]:not([aria-invalid='false']),
  &:user-invalid,
  &[aria-invalid='true'] {
    accent-color: var(--color-alert-strong);
    outline: 1px solid var(--color-alert-strong);
    outline-offset: -1px;
  }
}

input[type='checkbox'][data-theme='toggle'],
[role='switch'] {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  width: var(--space-scale-5);
  height: 1.75rem;
  border-radius: 18px;
  color: var(--color-text-200);
  background-color: var(--color-surface-700);
  transition:
    color 0.25s,
    background-color 0.25s;
  cursor: pointer;
  display: block;
  border-color: transparent;
  border-width: 0px;
  padding: 2px;
  position: relative;
  isolation: isolate;
  min-width: var(--space-scale-5);

  &:hover {
    color: var(--color-text-300);
    background-color: var(--color-surface-800);
  }

  &[disabled],
  &[aria-disabled='true'] {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }

  &:checked,
  &[aria-checked='true'] {
    color: var(--color-success-strong);
    background-color: var(--color-success-strong);

    &:hover {
      color: #004200;
      background-color: oklch(from var(--color-success-strong) calc(l - 0.2) c h);
    }
  }

  &::before {
    content: '';
    position: absolute;
    top: 2px;
    right: calc(100% - 1.75rem + 2px);
    height: calc(100% - 4px);
    aspect-ratio: 1;
    border-radius: inherit;
    background-color: var(--color-surface-100);
    transition: right 0.25s ease;
    z-index: 1;
    padding: 4px;
    box-sizing: border-box;
  }

  &::after {
    content: '';
    -webkit-mask-image: url('assets/icons/close.svg');
            mask-image: url('assets/icons/close.svg');
    -webkit-mask-size: 18px;
            mask-size: 18px;
    -webkit-mask-position: center center;
            mask-position: center center;
    -webkit-mask-repeat: no-repeat;
            mask-repeat: no-repeat;
    position: absolute;
    top: 2px;
    right: calc(100% - 1.75rem + 2px);
    height: calc(100% - 4px);
    aspect-ratio: 1;
    border-radius: inherit;
    background-color: var(--color-surface-700);
    transition: right 0.25s ease;
    z-index: 2;
    padding: 4px;
    box-sizing: border-box;
  }

  &:is(:checked, [aria-checked='true']) {
    &::before,
    &::after {
      right: 2px;
    }

    &::after {
      -webkit-mask-image: url('assets/icons/tick.svg');
              mask-image: url('assets/icons/tick.svg');
      -webkit-mask-size: 14px;
              mask-size: 14px;
      background-size: 12px;
      background-position: center center;
      -webkit-mask-position: center calc(50% + 1px);
              mask-position: center calc(50% + 1px);
      background-color: var(--color-success-strong);
    }
  }

  &[aria-invalid]:not([aria-invalid='false']),
  &:user-invalid {
    accent-color: var(--color-alert-strong);
  }
}
}
@layer base{
label, fieldset > legend {
  font-size: var(--font-size-200);
  line-height: 1.5;
  font-weight: var(--font-weight-normal);
  color: var(--color-text-300);
}
}
@layer base{

input[type='number'] {
  position: relative;
}

input[type='number']::-webkit-inner-spin-button {
  position: absolute;
  top: var(--space-scale-0-5);
  right: var(--input-horizontal-spacing, var(--space-scale-2));
  height: calc(100% - var(--space-scale-1));
}
}
@layer base{

@property --radio-size {
  syntax: '<length>';
  inherits: true;
  initial-value: 1rem;
}

@property --radio-accent-color {
  syntax: '<color>';
  inherits: true;
  initial-value: #5E43C2;
}

input[type='radio'] {
  --radio-size: var(--space-scale-2);
  --radio-accent-color: var(--color-primary-400);

  -webkit-appearance: none;

     -moz-appearance: none;

          appearance: none;
  accent-color: var(--radio-accent-color);
  width: var(--radio-size);
  aspect-ratio: 1;
  cursor: pointer;
  border: 1px solid var(--radio-accent-color);
  border-radius: 50%;

  display: inline-grid;
  place-content: center;
  margin: 0;

  &::before {
    transform: scale(0);
    content: '';
    width: calc(var(--radio-size) * 0.75);
    aspect-ratio: 1;
    border-radius: 50%;
    transition: 120ms transform ease-in-out;
    background: var(--radio-accent-color);
  }

  &:checked::before {
    transform: scale(1);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;

    + label {
      opacity: 0.75;
    }
  }
}
}
@layer base{

@property --select-border-color {
  syntax: '<color>';
  inherits: true;
  initial-value: #C5C8CE;
}

@property --select-background-color {
  syntax: '<color>';
  inherits: true;
  initial-value: #FFFFFF;
}

@property --select-hover-background-color {
  syntax: '<color>';
  inherits: true;
  initial-value: #F1F2F4;
}

@property --select-min-width {
  syntax: '<length>';
  inherits: true;
  initial-value: 250px;
}

@property --select-max-width {
  syntax: '<length>';
  inherits: true;
  initial-value: 300px;
}

select {
  align-items: center;
  background-color: var(--select-background-color);
  border-style: solid;
  border-width: 1px;
  border-radius: var(--border-radius);
  border-color: var(--select-border-color);
  color: var(--color-text-400);
  display: flex;
  font-family: var(--font-family-sans);
  font-size: var(--font-size-200);
  line-height: 1.3;
  max-width: var(--select-max-width);
  min-width: var(--select-min-width);
  padding: 0.5rem;

  &::picker-icon {
    content: '';
    height: 12px;
    width: 12px;

    background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" fill="currentcolor" width="12" height="12" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" stroke="currentcolor"/></svg>');
    background-size: cover;
    transition: rotate 0.2s allow-discrete;
  }

  &:open::picker-icon {
    rotate: -180deg;
  }

  &:hover {
    background-color: var(--select-hover-background-color);
  }
}

@supports ((-webkit-appearance: base-select) or (-moz-appearance: base-select) or (appearance: base-select)) {
  select,
  ::picker(select) {
    -webkit-appearance: base-select;
       -moz-appearance: base-select;
            appearance: base-select;
  }

  ::picker(select) {
    border: 1px solid var(--select-border-color);
    border-radius: var(--border-radius);
    top: calc(anchor(bottom) + var(--space-scale-1));
  }

  option {
    text-align: left;
    padding: var(--space-scale-1);
    font-size: var(--font-size-200);
    font-weight: var(--font-weight-normal);
    color: var(--color-text-400);
    line-height: 1.1;
    box-sizing: border-box;
  }

  option:is(:hover, :focus) {
    background-color: var(--select-hover-background-color);
    outline: none;
  }
  option:checked {
    font-weight: var(--font-weight-medium);
    color: var(--color-primary-400);
  }

  option::checkmark {
    display: none;
  }
}
}
@layer base{
input:not([type='checkbox'], [type='radio']),
textarea {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background-color: var(--input-background-color, var(--color-surface-100));
  border-color: var(--input-border-color, var(--color-border-400));
  border-radius: var(--border-radius-100);
  border-style: solid;
  border-width: var(--input-border-width, 1px);
  box-sizing: border-box;
  color: var(--input-color, inherit);
  height: var(--input-height, var(--space-scale-4));
  padding: var(--input-vertical-spacing, 0) var(--input-horizontal-spacing, var(--space-scale-2));
  font-family: var(--font-family-sans);
  font-size: var(--font-size-100);
  line-height: var(--line-height-200);
  transition:
    background-color ease-in 100ms,
    border-color ease-in 200ms;
  width: 100%;

  &:hover {
    --input-background-color: var(--color-surface-300);
  }

  &::-moz-placeholder {
    font-size: var(--font-size-100);
    color: var(--placeholder-color, var(--color-text-300));
  }

  &::placeholder {
    font-size: var(--font-size-100);
    color: var(--placeholder-color, var(--color-text-300));
  }

  &:focus {
    outline: none;
    border-color: var(--input-focus-border-color, var(--color-primary-400));
    box-shadow: 0px 0px 0px 4px rgba(1, 150, 237, 0.24);
  }

  &:disabled,
  [aria-disabled='true'] {
    --input-color: var(--color-text-200);
    --placeholder-color: var(--color-text-200);
    --input-background-color: var(--color-surface-200);
  }

  &[aria-invalid]:not([aria-invalid='false']),
  &:user-invalid {
    --input-border-color: var(--color-alert-strong);
    --input-focus-border-color: var(--color-alert-strong);
  }
}
}
@layer base{
textarea {
  --input-vertical-spacing: var(--space-scale-2);
  --input-height: auto;
  resize: none;
  text-align: left;
}
}
@layer base{
h1,
h2,
h3,
h4 {
  font-family: var(--font-family-inter);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-500);
}

.display {
  font-size: var(--font-size-600);
  line-height: var(--font-line-height-600);
}

h1,
.heading-1 {
  font-size: var(--font-size-500);
  line-height: var(--font-line-height-500);
}

h2,
.heading-2 {
  font-size: var(--font-size-400);
  line-height: var(--font-line-height-400);
}

h3,
.heading-3 {
  font-size: var(--font-size-300);
  line-height: var(--font-line-height-300);
}

h4,
.heading-4 {
  font-size: var(--font-size-200);
  line-height: var(--font-line-height-200);
}

p,
.body {
  line-height: var(--font-line-height-200);
  font-size: var(--font-size-200);
  color: var(--color-text-400);
}

strong,
.strong {
  font-weight: var(--font-weight-semibold);
}

.small {
  font-size: var(--font-size-100);
  line-height: var(--font-line-height-100);
}

a {
  font-weight: var(--font-weight-medium);
  color: var(--color-primary-400);
  cursor: pointer;
  text-decoration: none;
  line-height: 1.4;
}

.text-error,
.text-danger {
  color: var(--color-alert-strong);
}

.text-success {
  color: var(--color-success-strong);
}

body {
  color: var(--color-text-500);
  font-weight: var(--font-weight-normal);
  font-size: var(--font-size-200);
}
}
/* noinspection CssInvalidAtRule */
@layer blocks{
.badge {
  display: inline-block;
  width: -moz-fit-content;
  width: fit-content;
  height: -moz-fit-content;
  height: fit-content;
  border-radius: var(--border-radius-50);
  padding: 0 var(--space-scale-1);
  font-weight: var(--font-weight-normal);
  font-size: var(--font-size-200);
  line-height: var(--font-line-height-200);
  background-color: var(--color-surface-300);
  color: var(--color-text-400);

  &[data-theme='subtle'] {
    background-color: var(--color-surface-200);
  }

  &[data-theme='danger'] {
    background-color: var(--color-alert-subtle);
    color: var(--color-alert-strong);
  }

  &[data-theme='success'] {
    background-color: var(--color-success-subtle);
    color: var(--color-success-strong);
  }

  &[data-theme='warning'] {
    background-color: var(--color-warning-subtle);
    color: var(--color-warning-strong);
  }

  &[data-theme='info'] {
    background-color: var(--color-info-subtle);
    color: var(--color-info-strong);
  }

  &[data-theme='primary'] {
    background-color: var(--color-primary-100);
    color: var(--color-primary-400);
  }
}
}
@layer blocks{
.banner {
  display: grid;
  gap: var(--space-scale-0-5);
  grid-template-columns: min-content 1fr max-content;
  grid-template-areas: 'icon body action';
  align-items: center;
  padding: var(--space-scale-1);
  border-radius: var(--border-radius-100);
  color: var(--color-text-400);
  background-color: var(--color-info-subtle);

  .banner--body {
    grid-area: body;
    font-size: var(--font-size-100);
  }

  .banner--action {
    grid-area: action;
  }

  .banner--title {
    font-weight: var(--font-weight-semibold);
    grid-area: title;
  }

  &:has(.banner--title) {
    grid-template-rows: min-content 1fr;
    grid-template-areas:
      'icon title action'
      '. body .';
  }

  &::before {
    display: block;
    grid-area: icon;
    content: '';
    width: 24px;
    height: 24px;
    background-color: var(--color-info-strong);
    -webkit-mask-image: url('data:image/svg+xml;utf8,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM11.25 15.75C11.25 16.1642 11.5858 16.5 12 16.5C12.4142 16.5 12.75 16.1642 12.75 15.75V10.25C12.75 9.83579 12.4142 9.5 12 9.5C11.5858 9.5 11.25 9.83579 11.25 10.25V15.75ZM12.75 7.75C12.75 7.33579 12.4142 7 12 7C11.5858 7 11.25 7.33579 11.25 7.75C11.25 8.16421 11.5858 8.5 12 8.5C12.4142 8.5 12.75 8.16421 12.75 7.75Z" fill="currentColor"/> </svg>');
            mask-image: url('data:image/svg+xml;utf8,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM11.25 15.75C11.25 16.1642 11.5858 16.5 12 16.5C12.4142 16.5 12.75 16.1642 12.75 15.75V10.25C12.75 9.83579 12.4142 9.5 12 9.5C11.5858 9.5 11.25 9.83579 11.25 10.25V15.75ZM12.75 7.75C12.75 7.33579 12.4142 7 12 7C11.5858 7 11.25 7.33579 11.25 7.75C11.25 8.16421 11.5858 8.5 12 8.5C12.4142 8.5 12.75 8.16421 12.75 7.75Z" fill="currentColor"/> </svg>');
  }

  &[data-theme='warning'] {
    color: var(--color-text-400);
    background-color: var(--color-warning-subtle);

    &::before {
      background-color: var(--color-warning-strong);
      -webkit-mask-image: url('data:image/svg+xml;utf8,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM11.25 7.75C11.25 7.33579 11.5858 7 12 7C12.4142 7 12.75 7.33579 12.75 7.75V13.25C12.75 13.6642 12.4142 14 12 14C11.5858 14 11.25 13.6642 11.25 13.25V7.75ZM12.75 15.75C12.75 16.1642 12.4142 16.5 12 16.5C11.5858 16.5 11.25 16.1642 11.25 15.75C11.25 15.3358 11.5858 15 12 15C12.4142 15 12.75 15.3358 12.75 15.75Z" fill="currentColor"/> </svg>');
              mask-image: url('data:image/svg+xml;utf8,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM11.25 7.75C11.25 7.33579 11.5858 7 12 7C12.4142 7 12.75 7.33579 12.75 7.75V13.25C12.75 13.6642 12.4142 14 12 14C11.5858 14 11.25 13.6642 11.25 13.25V7.75ZM12.75 15.75C12.75 16.1642 12.4142 16.5 12 16.5C11.5858 16.5 11.25 16.1642 11.25 15.75C11.25 15.3358 11.5858 15 12 15C12.4142 15 12.75 15.3358 12.75 15.75Z" fill="currentColor"/> </svg>');
    }
  }

  &[data-theme='alert'] {
    color: var(--color-text-400);
    background-color: var(--color-alert-subtle);

    &::before {
      background-color: var(--color-alert-strong);
      -webkit-mask-image: url('data:image/svg+xml;utf8,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM11.25 7.75C11.25 7.33579 11.5858 7 12 7C12.4142 7 12.75 7.33579 12.75 7.75V13.25C12.75 13.6642 12.4142 14 12 14C11.5858 14 11.25 13.6642 11.25 13.25V7.75ZM12.75 15.75C12.75 16.1642 12.4142 16.5 12 16.5C11.5858 16.5 11.25 16.1642 11.25 15.75C11.25 15.3358 11.5858 15 12 15C12.4142 15 12.75 15.3358 12.75 15.75Z" fill="currentColor"/> </svg>');
              mask-image: url('data:image/svg+xml;utf8,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM11.25 7.75C11.25 7.33579 11.5858 7 12 7C12.4142 7 12.75 7.33579 12.75 7.75V13.25C12.75 13.6642 12.4142 14 12 14C11.5858 14 11.25 13.6642 11.25 13.25V7.75ZM12.75 15.75C12.75 16.1642 12.4142 16.5 12 16.5C11.5858 16.5 11.25 16.1642 11.25 15.75C11.25 15.3358 11.5858 15 12 15C12.4142 15 12.75 15.3358 12.75 15.75Z" fill="currentColor"/> </svg>');
    }
  }
}
}
@layer blocks{

.card,
.card-dataview {
  border-radius: var(--border-radius-100);
  border: 1px solid var(--color-border-100);
  background-color: var(--color-surface-100);
  box-shadow: var(--box-shadow-sm);
  padding: var(--space-scale-2);
  display: flex;
  flex-direction: column;
  gap: var(--space-scale-1);
  font-size: var(--font-size-200);
  font-weight: var(--font-weight-normal);
  line-height: 1.5;

  .value {
    font-size: var(--font-size-600);
    font-weight: var(--font-weight-normal);
    line-height: normal;
    display: block;
    font-family: var(--font-family-serif);
  }
}

.card-dataview {
  gap: 0;
  padding: var(--space-scale-2);

  display: grid;
  grid-template-rows: repeat(4, 1fr);

  .title {
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
  }

  .status {
    align-self: center;
  }
}
}
@layer blocks{

.accordion:has(+ .accordion) {
  border-top: 1px solid var(--color-border-200);
  border-bottom: 1px solid var(--color-border-200);
}

.accordion + .accordion {
  border-top: none;
  border-bottom: 1px solid var(--color-border-200);
}

.accordion {
  summary {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    padding: var(--space-scale-1-5) var(--space-scale-2);
    font-size: var(--font-size-200);
    font-weight: var(--font-weight-semibold);
    color: var(--color-text-500);

    &:hover {
      background-color: var(--color-surface-300);
    }

    &::after {
      content: '';
      display: block;
      width: 12px;
      height: 12px;
      flex-shrink: 0;
      background-color: var(--color-text-300);
      -webkit-mask-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/></svg>');
              mask-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/></svg>');
      -webkit-mask-repeat: no-repeat;
              mask-repeat: no-repeat;
      -webkit-mask-size: contain;
              mask-size: contain;
      transition: transform 200ms ease;
    }
  }

  &[open] summary::after {
    transform: rotate(180deg);
  }

  & > :not(summary) {
    margin-left: var(--space-scale-2);
    margin-right: var(--space-scale-2);

    &:nth-child(2) {
      margin-top: var(--space-scale-0-5);
    }

    &:last-child {
      margin-bottom: var(--space-scale-1-5);
    }
  }
}
}
@layer blocks{
header[data-theme='top-nav'] {
  background-color: var(--color-surface-800);
  color: var(--color-text-100);
  padding: var(--space-scale-2) var(--space-scale-6);
  min-height: var(--space-scale-7-5);
  display: flex;
  align-items: center;
  gap: var(--space-scale-4);
  width: 100%;
  box-sizing: border-box;

  img {
  }

  nav {
    > ul {
      display: flex;
      gap: var(--space-scale-3);
      list-style: none;
      margin: 0;
      padding: 0;
      align-items: center;
      height: 100%;
    }

    a {
      color: inherit;
      text-underline-offset: var(--space-scale-1-5);
      font-weight: var(--font-weight-bold);
      font-size: var(--font-size-100);

      &:is(:hover, [data-active='true']) {
        text-decoration: underline;
        text-decoration-thickness: 2px;
        text-decoration-color: var(--color-primary-300);
      }
    }
  }
}
}
@layer blocks{
.statistic {
  display: grid;
  width: 100%;
  grid-template-columns: min-content 1fr;
  grid-template-rows: repeat(3, min-content);
  grid-template-areas:
    'label label'
    'value indicator'
    'context context';
  -moz-column-gap: var(--space-scale-1);
       column-gap: var(--space-scale-1);
  row-gap: var(--space-scale-0-5);
  align-items: center;

  .statistic--indicator {
    grid-area: indicator;

    &:not(.badge) {
      font-size: var(--font-size-100);
    }
  }

  .statistic--label {
    grid-area: label;
    color: var(--color-text-300);
  }

  .statistic--value {
    grid-area: value;
    gap: var(--space-scale-1);
    font-size: var(--font-size-500);
    font-weight: var(--font-weight-semibold);
  }

  .statistic--context {
    grid-area: context;
    color: var(--color-text-300);
    font-size: var(--font-size-100);
  }
}
}
@layer blocks{

@property --tag-background-color {
  syntax: '<color>';
  inherits: true;
  initial-value: #FFFFFF;
}

@property --tag-color {
  syntax: '<color>';
  inherits: true;
  initial-value: #0D0C0D;
}

.status {
  --tag-background-color: var(--color-surface-100);
  --tag-color: var(--color-text-500);

  background-color: var(--tag-background-color);
  color: var(--tag-color);
  border-radius: var(--border-radius-100);
  padding: var(--space-scale-0-5) var(--space-scale-1);
  font-size: var(--font-size-100);
  width: -moz-fit-content;
  width: fit-content;
  height: -moz-fit-content;
  height: fit-content;

  &[data-status='warning'] {
    --tag-background-color: var(--color-warning-subtle);
    --tag-color: var(--color-warning-strong);
  }
}
}
@layer blocks{

table {
    width: 100%;
    border: 1px solid var(--color-surface-500);
    line-height: var(--font-line-height-200);
    color: var(--color-text-400);
}

thead {
    background-color: var(--color-surface-300);
    color: var(--color-text-400);
}

tbody {
    background-color: var(--color-surface-100);
}

th {
    text-align: left;
    padding: var(--space-scale-2);
    border: 1px solid var(--color-border-200);

    &[data-sort-key] {
        cursor: pointer;
        padding: 0;

        & button {
            all: unset;
            cursor: pointer;
            width: 100%;
            padding: var(--space-scale-2);
            box-sizing: border-box;

            &:focus-visible {
                outline: 4px solid rgba(1, 150, 237, 0.24);
                outline-offset: 2px;
            }

            &::after {
                content: '';
                display: inline-block;
                width: var(--font-size-200);
                height: var(--font-size-200);
                vertical-align: -0.1em;
                background-color: currentColor;
                -webkit-mask-size: contain;
                        mask-size: contain;
                -webkit-mask-repeat: no-repeat;
                        mask-repeat: no-repeat;
                -webkit-mask-position: center;
                        mask-position: center;
                margin-left: var(--space-scale-1);
                -webkit-mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Cpath d='M15.5 4.707C15.914 4.707 16.25 5.043 16.25 5.457V17.147l1.22-1.22a.75.75 0 0 1 1.06 1.06L15.5 20.018l-3.03-3.03a.75.75 0 0 1 1.06-1.06l1.22 1.22V5.457c0-.414.336-.75.75-.75ZM11.53 7.427a.75.75 0 0 1-1.06 1.06L9.25 7.268V18.957a.75.75 0 0 1-1.5 0V7.268L6.53 8.487a.75.75 0 0 1-1.06-1.06L8.5 4.396l3.03 3.03Z' fill='white'/%3E%3C/svg%3E");
                        mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Cpath d='M15.5 4.707C15.914 4.707 16.25 5.043 16.25 5.457V17.147l1.22-1.22a.75.75 0 0 1 1.06 1.06L15.5 20.018l-3.03-3.03a.75.75 0 0 1 1.06-1.06l1.22 1.22V5.457c0-.414.336-.75.75-.75ZM11.53 7.427a.75.75 0 0 1-1.06 1.06L9.25 7.268V18.957a.75.75 0 0 1-1.5 0V7.268L6.53 8.487a.75.75 0 0 1-1.06-1.06L8.5 4.396l3.03 3.03Z' fill='white'/%3E%3C/svg%3E");
            }
        }
    }

    &[aria-sort='ascending'] button::after {
        -webkit-mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M17.573 10.988a.75.75 0 0 1-1.06 0L12.793 7.268v11.69a.75.75 0 0 1-1.5 0V7.268l-3.72 3.72a.75.75 0 0 1-1.06-1.061l5.53-5.53 5.53 5.53a.75.75 0 0 1 0 1.06Z' fill='white'/%3E%3C/svg%3E");
                mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M17.573 10.988a.75.75 0 0 1-1.06 0L12.793 7.268v11.69a.75.75 0 0 1-1.5 0V7.268l-3.72 3.72a.75.75 0 0 1-1.06-1.061l5.53-5.53 5.53 5.53a.75.75 0 0 1 0 1.06Z' fill='white'/%3E%3C/svg%3E");
    }

    &[aria-sort='descending'] button::after {
        -webkit-mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M6.513 13.013a.75.75 0 0 1 1.06 0l3.72 3.72V5.043a.75.75 0 0 1 1.5 0v11.69l3.72-3.72a.75.75 0 0 1 1.06 1.06l-5.53 5.531-5.53-5.53a.75.75 0 0 1 0-1.061Z' fill='white'/%3E%3C/svg%3E");
                mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M6.513 13.013a.75.75 0 0 1 1.06 0l3.72 3.72V5.043a.75.75 0 0 1 1.5 0v11.69l3.72-3.72a.75.75 0 0 1 1.06 1.06l-5.53 5.531-5.53-5.53a.75.75 0 0 1 0-1.061Z' fill='white'/%3E%3C/svg%3E");
    }
}

tr:hover{
    background-color: var(--color-surface-200);
}

td {
    padding: var(--space-scale-2);
    text-align: left;
    vertical-align: middle;
    border: 1px solid var(--color-border-200);

    &:first-child {
        text-align: left;
    }
}
}
/* noinspection CssInvalidAtRule */
@layer compositions{

@property --column-vertical-spacing {
  syntax: '<length>';
  inherits: true;
  initial-value: 0.5rem;
}

[class^='column'] {
  display: flex;
  flex-direction: column;
  gap: var(--column-vertical-spacing, var(--space-scale-1));

  &[data-align='end'] {
    align-items: flex-end;
  }

  &[data-align='center'] {
    align-items: center;
  }

  &[data-align='start'] {
    align-items: flex-start;
  }

  &[data-justify='end'] {
    justify-content: flex-end;
  }

  &[data-justify='center'] {
    justify-content: center;
  }
}

.column-xs {
  --column-vertical-spacing: var(--space-scale-0-5);
}

.column-sm {
  --column-vertical-spacing: var(--space-scale-1);
}

.column-md {
  --column-vertical-spacing: var(--space-scale-2);
}

.column-lg {
  --column-vertical-spacing: var(--space-scale-3);
}

.column-xl {
  --column-vertical-spacing: var(--space-scale-4);
}

.column-2xl {
  --column-vertical-spacing: var(--space-scale-5);
}
}
@layer compositions{

@property --stack-vertical-spacing {
  syntax: '<length>';
  inherits: true;
  initial-value: 0.5rem;
}

[class^='stack'] > * + * {
  margin-top: var(--stack-vertical-spacing);
}

.stack-xs {
  --stack-vertical-spacing: var(--space-scale-0-5);
}

.stack-sm {
  --stack-vertical-spacing: var(--space-scale-1);
}

.stack-md {
  --stack-vertical-spacing: var(--space-scale-2);
}

.stack-lg {
  --stack-vertical-spacing: var(--space-scale-3);
}

.stack-xl {
  --stack-vertical-spacing: var(--space-scale-4);
}

.stack-2xl {
  --stack-vertical-spacing: var(--space-scale-5);
}
}
/* noinspection CssInvalidAtRule */
@layer exceptions{
/**
  Hide web componentManifest until they are defined
 */
:is(tt-combobox, tt-navbar, tt-date-picker, tt-date-range-picker):not(:defined) {
  visibility: hidden;
}
}
`;
